import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 6,5.25 c -0.1919423,0 -0.3848051,0.072305 -0.53125,0.21875 -0.2928897,0.2928897 -0.2928897,0.7696103 0,1.0625 L 10.939453,12 5.46875,17.46875 c -0.2928897,0.2929 -0.2928897,0.7696 0,1.0625 0.2928897,0.2929 0.7696103,0.2929 1.0625,0 L 12,13.060547 17.46875,18.53125 c 0.2929,0.2929 0.7696,0.2929 1.0625,0 0.2929,-0.2929 0.2929,-0.7696 0,-1.0625 L 13.060547,12 18.53125,6.53125 c 0.2929,-0.2928897 0.2929,-0.7696103 0,-1.0625 -0.2929,-0.2928897 -0.7696,-0.2928897 -1.0625,0 L 12,10.939453 6.53125,5.46875 C 6.3848051,5.3223051 6.1919423,5.25 6,5.25 Z"
	})]
});
export default SvgCloseLine;
